import { motion } from "framer-motion";
import { useLang } from "../i18n";

const BEES_IMG = "https://images.pexels.com/photos/7176847/pexels-photo-7176847.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const COMB_IMG = "https://images.unsplash.com/photo-1718146921295-700b969e7c78?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function About() {
  const { t } = useLang();
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16" data-testid="about-page">
      <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-mono text-xs uppercase tracking-[0.25em] text-amber-800">{t("about.eyebrow")}</motion.p>
      <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
        className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-3xl leading-tight" data-testid="about-title">
        {t("about.title")}
      </motion.h1>
      <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
        <div className="space-y-8">
          {[t("about.p1"), t("about.p2"), t("about.p3")].map((p, i) => (
            <motion.p key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.15 }} className="text-lg text-cocoa/75 leading-relaxed" data-testid={`about-paragraph-${i}`}>
              {p}
            </motion.p>
          ))}
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.5 }}
            className="font-mono text-sm tracking-widest text-honey">— FAMIGLIA LOMIELLINA, LOMELLINA (PV)</motion.p>
        </div>
        <div className="space-y-6">
          <motion.div initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="relative">
            <div className="absolute -top-4 -right-4 w-full h-full border border-honey/40 rounded-sm" />
            <img src={BEES_IMG} alt="Api su favo" className="relative rounded-sm w-full aspect-[4/3] object-cover shadow-xl" />
          </motion.div>
          <motion.img initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }}
            src={COMB_IMG} alt="Favo di miele" className="rounded-sm w-2/3 aspect-[4/3] object-cover shadow-xl ml-auto" />
        </div>
      </div>
    </div>
  );
}
